import { useSearchParams } from "react-router-dom";

import { SegmentedFilter } from "../../components/ui/SegmentedFilter";
import { t } from "../../lib/i18n";
import { AppGroupsPage } from "../network/AppGroupsPage";
import { DeviceGroupsPage } from "../network/DeviceGroupsPage";
import { URLGroupsPage } from "../network/URLGroupsPage";

type GroupKind = "url" | "app" | "device";

export function PoliciesGroupsTab() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("kind");
  const kind: GroupKind = raw === "app" || raw === "device" ? raw : "url";
  const setKind = (next: GroupKind) => {
    const updated = new URLSearchParams(params);
    updated.set("kind", next);
    updated.delete("group");
    setParams(updated);
  };
  return (
    <div className="stack">
      <div className="row" style={{ justifyContent: "flex-start" }}>
        <SegmentedFilter<GroupKind>
          value={kind}
          onChange={setKind}
          options={[
            { value: "url", label: t("policies.groups.kind.url") },
            { value: "app", label: t("policies.groups.kind.app") },
            { value: "device", label: t("policies.groups.kind.device") },
          ]}
          ariaLabel={t("policies.tabs.groups")}
        />
      </div>
      {kind === "url" && <URLGroupsPage />}
      {kind === "app" && <AppGroupsPage />}
      {kind === "device" && <DeviceGroupsPage />}
    </div>
  );
}
